export const animations = {
    durationStandard: 100,
    durationLong: 600,
    timingStandard: "ease",
    toastDurationShort: 3000,
    toastDurationLong: 4000,
    spinnerPageLoad: 200,
    animateQueue: false
};
